import { FC, useMemo } from 'react';

import { GmailThreads, OutlookMessage, Token } from 'utils/types';
// eslint-disable-next-line max-len
import GmailComposerEmail from 'modules/account/contact/containers/Leads/Emails/gmail/GmailComposerEmail';
// eslint-disable-next-line max-len
import OutlookComposerEmail from 'modules/account/contact/containers/Leads/Emails/outlook/OutlookComposerEmail';

import ComposerIntegrationDialog from './ComposerIntegrationDialog';

type ComposerEmailProps = {
  attachments: File[];
  setAttachments: React.Dispatch<React.SetStateAction<File[]>>;
  closeComposer: () => void;
  setThreads?: React.Dispatch<React.SetStateAction<GmailThreads>>;
  setMessages?: React.Dispatch<React.SetStateAction<OutlookMessage[]>>;
  token: Token;
};

const ComposerEmail: FC<ComposerEmailProps> = ({
  attachments,
  setAttachments,
  closeComposer,
  setThreads,
  setMessages,
  token,
}) => {
  const composerToRender = useMemo(() => {
    if (token) {
      switch (token.source) {
        case 'GOOGLE':
          return (
            <GmailComposerEmail
              attachments={attachments}
              setAttachments={setAttachments}
              closeComposer={closeComposer}
              setThreads={setThreads}
              token={token}
            />
          );
        case 'AZURE':
          return (
            <OutlookComposerEmail
              attachments={attachments}
              setAttachments={setAttachments}
              closeComposer={closeComposer}
              setMessages={setMessages}
              token={token}
            />
          );
        default:
          return (
            <GmailComposerEmail
              attachments={attachments}
              setAttachments={setAttachments}
              closeComposer={closeComposer}
              setThreads={setThreads}
              token={token}
            />
          );
      }
    } else {
      return <ComposerIntegrationDialog />;
    }
  }, [
    attachments,
    closeComposer,
    setAttachments,
    setMessages,
    setThreads,
    token,
  ]);

  // if (tokensData?.data.length === 0) {
  //   return <ComposerIntegrationDialog />;
  // }

  return composerToRender;
};

export default ComposerEmail;
